<template>
  <subjects @onUpdate="onUpdate" :config="config" />
</template>

<script>
import AdminSubjects from "./AdminSubjects"

export default {
  name: 'AdminSubjectsReproved',
  components: { 'subjects': AdminSubjects },
  data: (vm) => {
    return {
      config: {
        title: 'Cadastros Reprovados',
        empty: 'Não existem cadastros reprovados neste momento.',
        navItems: [{ url: '/admin/subjects/reproved', title: 'Cadastros Reprovados', icon: 'dashboard' }],
        load_url: vm.$root.urls.admin_companies_reproved
      }
    }
  },
  methods: {
    onUpdate(companies, record) {
      if ((record.clearance_level * 1) > 0) {
        companies.splice(companies.findIndex(el => el.id === record.id), 1)
      }
    }
  }
}

</script>




// WEBPACK FOOTER //
// src/AdminSubjectsReproved.vue